var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('img',{attrs:{"src":_vm.componentImage}}),_c('h3',[_vm._v("Oops! Forgot to specify a component?")])])
}
var staticRenderFns = []

export { render, staticRenderFns }